export default __webpack_public_path__ + "static/media/logo-emgea.586f2ebe.svg";